import React from 'react';
import { ErrorBanner } from './Notifications';
import LoadingWithLogo from './LoadingWithLogo';

export default function PanelNotifications({
  isScanning,
  scanError,
  hasExtractedData,
  onRetryScan,
  onDismissScanError
}) {
  if (isScanning) {
    return <LoadingWithLogo message="Extracting information..." />;
  }

  if (scanError && !hasExtractedData) {
    return (
      <ErrorBanner
        message={scanError}
        onRetry={onRetryScan}
        onDismiss={onDismissScanError}
      />
    );
  }

  return null;
}

